jQuery(document).ready(function($) {
    $(".working-hours__see-more-link").click(function(e) {
      e.preventDefault();
  
      var workingHoursContainer = $(this).parent(".working-hours__items");
  
      // Toggle the visibility of additional items
      workingHoursContainer.find(".working-hours__item--additional").toggleClass("hidden");
  
      // Update the link text based on the visibility of additional items
      if (workingHoursContainer.find(".working-hours__item--additional").hasClass("hidden")) {
        $(this).text("See more");
      } else {
        $(this).text("See less");
      }
    });
  });
  